export enum Currencies {
  RUB = 'rub',
  USD = 'usd',
}
